import React from 'react'
import { Box } from '@mui/joy'
import JSONPretty from 'react-json-pretty'
import { useTranslation } from 'react-i18next';

const CellAudienceLead = ({ value, type = 'simple' }) => {
    const { t } = useTranslation();
    return (
        <Box className={"list-element-cell cell-" + type}>
            {
                value?.type == 'business' && `${value?.companyName} (B2B | ${value?.source})`
            }
            {
                value?.type == 'retail' && `${value?.firstname} ${value?.lastname} (B2C | ${value?.source})`
            }
            {
                !value && <em style={{color:'#888'}}>{t('lead_removed')}</em>
            }
        </Box>
    )
}

export default CellAudienceLead